/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { Formik } from "formik";
import Modal from "../../../../../components/common/Modal/Modal";
import styles from "./AddLeader.styles";
import Dropdown from "../../../../../components/common/new/Dropdown/Dropdown";
// import AsyncAutoComplete from "../../../../../components/common/new/AutoCompleteDropdown/AsyncAutoComplete";
// import Member from "../../../../../services/api/member";
import Button from "../../../../../components/common/Button";
import InputField from "../../../../../components/common/new/InputField/InputField";
import IntroductionForm from "../../../../../services/api/introductionForm";
// import { getDropdownOptions } from "../../../../../utils";

const DIVISION_OPTIONS = [
  {
    value: 1,
    key: "MD",
  },
  {
    value: 2,
    key: "WD",
  },
  {
    value: 37,
    key: "YMD",
  },
  {
    value: 3,
    key: "YWD",
  },
];

function AddLeader({ open, onClose, onFormSubmit }) {
  const [positions, setPositions] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [subDivisions, setSubDivisions] = useState([]);

  const getPositions = async () => {
    try {
      const [mainlinePositionsRes, othersPositionRes] = await Promise.all([
        IntroductionForm.getAllPositions("MAINLINE_POSITION"),
        IntroductionForm.getAllPositions("DEPUTY_POSITION"),
      ]);

      const mainlineFormattedPos =
        mainlinePositionsRes?.data?.map((d) => ({
          key: d.name,
          value: d.positionId,
        })) ?? [];

      const othersFormattedPos =
        othersPositionRes?.data?.map((d) => ({
          key: d.name,
          value: d.positionId,
        })) ?? [];

      setPositions([...mainlineFormattedPos, ...othersFormattedPos]);
    } catch (error) {
      console.log(error);
    }
  };

  const getDivision = async () => {
    const { data } = await IntroductionForm.getDivisions();
    if (data?.length) {
      setDivisions(data);
    }
  };

  const onSubmit = (formValues) => {
    const selectedDivision = divisions.find(
      (d) => d.divisionId === formValues.divisionId
    );
    const selectedSubDivision = subDivisions.find(
      (d) => d.divisionId === formValues.subDivisionId
    );
    const selectedPosition = positions.find(
      (p) => p.value === formValues.positionId
    );

    const newFormValues = {
      ...formValues,
      divisionName: selectedDivision.name,
      subDivisionName: selectedSubDivision ? selectedSubDivision.name : "",
      positionName: selectedPosition.key,
    };
    onFormSubmit(newFormValues);
  };

  useEffect(() => {
    getPositions();
    getDivision();
  }, []);

  return (
    <Modal
      open={open}
      onClose={onClose}
      customStyle={{ maxHeight: "95%", maxWidth: "95%", overflow: "auto" }}
    >
      <Box style={styles.container}>
        <Formik
          onSubmit={onSubmit}
          initialValues={{
            divisionId: "",
            subDivisionId: "",
            positionId: "",
            memberName: "",
          }}
        >
          {({ values, handleChange, handleSubmit }) => (
            <form style={styles.formContainer} onSubmit={handleSubmit}>
              <Box style={styles.division}>
                <Dropdown
                  label="Select Divisions"
                  name="divisionId"
                  options={DIVISION_OPTIONS}
                  value={values.divisionId}
                  onChange={(e) => {
                    handleChange(e);
                    const selectedSubDivisions = divisions.find(
                      (d) => d.divisionId === e.target.value
                    )?.subDivisions;
                    setSubDivisions(selectedSubDivisions);
                  }}
                  required
                />
                {/* <Dropdown
                  label="Select Sub Divisions"
                  name="subDivisionId"
                  options={getDropdownOptions(
                    subDivisions,
                    "name",
                    "divisionId"
                  )}
                  value={values.subDivisionId}
                  onChange={handleChange}
                /> */}
              </Box>
              <Dropdown
                label="Position"
                name="positionId"
                options={positions}
                value={values.positionId}
                onChange={handleChange}
                required
              />
              <InputField
                value={values.memberName}
                name="memberName"
                onChange={handleChange}
                placeholder="Member Name"
                required
              />
              {/* Don't remove, will use in future */}
              {/* <AsyncAutoComplete
                sideLabel="Member Name"
                label="Member Name"
                placeholder="Search Member"
                api={Member.search}
                optionKey="fullName"
                value={values.memberSearch}
                optionValue="memberId"
                name="memberSearch"
                onChange={(option) => {
                  setFieldValue("memberSearch", option.value);
                }}
              /> */}
              <Box style={styles.actionButtons}>
                <Button label="Submit" type="submit" />
                <Button label="Cancel" variant="outlined" onClick={onClose} />
              </Box>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

export default AddLeader;
